import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addMacrosMicrosApi, listOfMacrosMicrosApi, updateMacrosMicrosApi } from "../../../../../config/Api";
export const AddMacrosAndMicros = () => {
    const { Option } = Select;
    const [category, setCategory] = useState('')

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [macrosMicrosData, setMacrosMicrosData] = useState()
    const [editMacrosMicrosRecord, setEditMacrosMicrosRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of all Recipe Macros Micros
    //==============================
    const getListOfMacrosMicros = () => {
        setLoading(true)

        listOfMacrosMicrosApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // call when user click on edit
    //==============================
    const editMacrosMicros = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        form.setFieldsValue({ 'tag_category': data.type })
        form.setFieldsValue({ 'unit': data.unit })
        setEditMacrosMicrosRecord(data);
    }

    useEffect(() => {
        getListOfMacrosMicros()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterMacrosMicros(macrosMicrosData);
    }, [macrosMicrosData]);

    // filter recipe macrod micros values
    //==============================
    const filterMacrosMicros = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.unit.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.type.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe macros micros
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateMacrosMicrosApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Macros Micros Update successfully",
                    });
                    getListOfMacrosMicros()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Tag Type',
            dataIndex: 'type',
            key: 'type',
            render: (text) => <a>{text}</a>,
            filters: [
                { text: "Micros", value: "Micros" },
                { text: "Macros", value: "Macros" },
            ],
            onFilter: (value, record) => record.type == value,
        },
        {
            title: 'Unit',
            dataIndex: 'unit',
            key: 'unit',
            // render: (text) => <a>{text}</a>,
            // filters: [
            //     { text: "Micros", value: "Micros" },
            //     { text: "Macros", value: "Macros" },
            // ],
            // onFilter: (value, record) => record.unit == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editMacrosMicros(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const data = [
        {
            id: '1',
            name: 'Vitamin A',
            type: 'Micros',
            unit: 'µg',
            status: true
        },
        {
            id: '2',
            name: 'Energy',
            type: 'Macros',
            unit: 'Kcal',
            status: false
        },
        {
            id: '4',
            name: 'Protein',
            type: 'Macros',
            unit: 'g',
            status: true
        },
        {
            id: '5',
            name: 'Total Fat',
            type: 'Macros',
            unit: 'g',
            status: true
        },
        {
            id: '6',
            name: 'Carbohydrate',
            type: 'Macros',
            unit: 'g',
            status: true
        },
        {
            id: '7',
            name: 'Dietary Fiber',
            type: 'Macros',
            unit: 'g',
            status: true
        },
        {
            id: '8',
            name: 'Ascorbic acids (C)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '10',
            name: 'Vitamin D',
            type: 'Micros',
            unit: 'µg',
            status: true
        },
        {
            id: '11',
            name: 'α -Tocopherol equivalent (E)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '12',
            name: 'Vitamin K',
            type: 'Micros',
            unit: 'µg',
            status: true
        },
        {
            id: '13',
            name: 'Thiamine (B1)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '14',
            name: 'Riboflavin (B2)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '15',
            name: 'Total B6',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '16',
            name: 'Folates (B9)',
            type: 'Micros',
            unit: 'µg',
            status: true
        },
        {
            id: '17',
            name: 'Calcium (Ca)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '18',
            name: 'Iron (Fe)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '19',
            name: 'Potassium (K)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '20',
            name: 'Sodium (Na)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '21',
            name: 'Zinc (Zn)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
        {
            id: '22',
            name: 'Phophorus (P)',
            type: 'Micros',
            unit: 'mg',
            status: true
        },
    ];

    const [form] = Form.useForm();

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "type": values.tag_category,
                "unit": values.unit,
                "status": true
            }
            addMacrosMicrosApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'tag_category': '' })
                        form.setFieldsValue({ 'unit': '' })
                        notification.success({
                            message: "Macros Micros added successfully",
                        });
                        getListOfMacrosMicros()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "type": values.tag_category,
                "unit": values.unit,
                "status": values.status
            }
            updateMacrosMicrosApi(editMacrosMicrosRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Macros Micros Update successfully",
                        });
                        getListOfMacrosMicros()
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'tag_category': '' })
                        form.setFieldsValue({ 'unit': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="AddMacrosAndMicros">
            <Row>
                <Col xl={17}>
                    <Form
                        name="AddMacrosAndMicrosForm"
                        className="AddMacrosAndMicros"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="AddMacrosAndMicrosForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="tag_category"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select Category!",
                                        },
                                    ]}
                                    initialValue=""
                                >
                                    <Select
                                        // value={regType}
                                        onChange={(e) => setCategory(e)}
                                    >
                                        <Option value="" disabled hidden>
                                            Select Category
                                        </Option>
                                        <Option value="Micros">Micros</Option>
                                        <Option value="Macros">Macros</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Name!",
                                        },
                                        // {
                                        //     pattern: CHARACTER_PATTERN,
                                        //     message: CHARACTER_PATTERN_MESSAGE,
                                        // }
                                    ]}
                                >
                                    <Input placeholder="Enter Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={4} className="ms-1">
                                <Form.Item
                                    name="unit"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Unit!",
                                        },
                                        // {
                                        //     pattern: CHARACTER_PATTERN,
                                        //     message: CHARACTER_PATTERN_MESSAGE,
                                        // }
                                    ]}
                                >
                                    <Input placeholder="Enter Unit" className="p-2" />
                                </Form.Item>
                            </Col>

                            <Col xl={3}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}>
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                </Col>
                <Col xl={2} className="text-end align-self-center">
                    <h6> Total: {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={5} className="align-self-center">
                    <Input.Search placeholder="Search Macros Micros"
                        onChange={(e) => { filterMacrosMicros(e.target.value); setMacrosMicrosData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100" />
                </Row>
            </Spin>
        </div >
    )
}
